module.exports = __webpack_public_path__ + "static/img/ex_logo_04.d135402.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tube_ex/ex_logo_04.jpg
// module id = EyQK
// module chunks = 0